import { IId, IOrganizationId, TNameTitle } from 'interfaces/common/common';

import { client } from '@api/client';
import { URL } from '@api/urls';

import { IAssetVisibility, IAssetVisibilityRestricted } from '@interfaces/assets/assetVisibility';
import { IGetAssetVisibilityRestrictedDTO, IUpdateAssetVisibilityDTO } from '@interfaces/assets/dto/assetVisibilityDTO';
import { IItemsResponse } from '@interfaces/common/response';

const {
	organizationProfile,
	assetVisibility,
	assetVisibilityRestricted,
	assetVisibilityRestrictedEnable,
	assetVisibilityRestrictedDisable,
	assetVisibilityTypes,
} = URL;

export const getAssetVisibility = ({ id }: IId): Promise<IAssetVisibility> => {
	return client.get(`${organizationProfile}/${id}/${assetVisibility}`);
};

export const getAssetVisibilityTypes = (): Promise<TNameTitle[]> => {
	return client.get(`${organizationProfile}/${assetVisibilityTypes}`);
};

export const getAssetVisibilityRestricted = ({
	id,
	...params
}: IGetAssetVisibilityRestrictedDTO): Promise<IItemsResponse<IAssetVisibilityRestricted>> => {
	return client.get(`${organizationProfile}/${id}/${assetVisibilityRestricted}`, { params });
};

export const updateAssetVisibility = ({ id, ...dto }: IUpdateAssetVisibilityDTO): Promise<IAssetVisibility> => {
	return client.post(`${organizationProfile}/${id}/${assetVisibility}`, dto);
};

export const enableRestrictedAssetVisibility = ({ id, ...dto }: IId & IOrganizationId): Promise<void> => {
	return client.post(`${organizationProfile}/${id}/${assetVisibilityRestrictedEnable}`, dto);
};

export const disableRestrictedAssetVisibility = ({ id, ...dto }: IId & IOrganizationId): Promise<void> => {
	return client.post(`${organizationProfile}/${id}/${assetVisibilityRestrictedDisable}`, dto);
};
